/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class relatedcause extends IceEntity {
  related_cause_key: string = "";
  related_cause_code: string = "";
  state_id: string = "";
  country_id: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "RELATED_CAUSE";
  }
}
